module.exports = __webpack_public_path__ + "img/transport.a8acd7a2.svg";